var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnterprisePlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9917 10L38 9.99561H37.9839L28.4999 5.00219L19.0002 0L9.50009 5.00219L0.0161387 9.99561H0L0.00825703 10L0 10.0044H0.0161387L9.50009 14.9978L19.0002 20L28.4999 14.9978L37.9839 10.0044H38L37.9917 10Z",
    fill: "#6AECD3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9917 29.9998L38 29.9958H37.9839L28.4999 25.0021L19.0002 20L9.50009 25.0021L0.0161387 29.9958H0L0.00825703 29.9998L0 30.0042H0.0161387L9.50009 34.9979L19.0002 40L28.4999 34.9979L37.9839 30.0042H38L37.9917 29.9998Z",
    fill: "#127C68"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10V30L19 20.0002L0 10Z",
    fill: "#1DCEAC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M38 10V30L19 20.0002L38 10Z",
    fill: "#1DCEAC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterprisePlan);
export default __webpack_public_path__ + "static/media/EnterprisePlan.415a8e855484d61452274f1543c82979.svg";
export { ForwardRef as ReactComponent };